import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../modules/shared/shared.module';
interface ToastType { success: 'success', error: 'error', warning: 'warning', info: 'info' }
interface DialogData { type: ToastType, message: string, duration?: number }
@Component({
  selector: 'app-dialog-toast',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './dialog-toast.component.html',
  styleUrl: './dialog-toast.component.css'
})
export class DialogToastComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: DialogData) { }
  @Input() panelClass: any;
}

